// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#connection-container {
  display: block;
  position: relative;
}
#connection-container .background {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: absolute;
  background: linear-gradient(135deg, var(--ion-color-primary) 0%, var(--ion-color-tertiary) 100%);
  opacity: 0.9;
}
@media (prefers-color-scheme: dark) {
  #connection-container .background {
    background: linear-gradient(135deg, #052829 0%, #03373e 100%);
  }
}
#connection-container .background-image {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: absolute;
  background-image: url('warehouse.jpg');
  background-repeat: no-repeat;
  background-position: bottom center;
  background-size: cover;
}
#connection-container > .scroll-content {
  background: none !important;
}
#connection-container .logo {
  background: none;
  display: block;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  margin-bottom: 15px;
  width: 30%;
  max-width: 150px;
  max-height: 150px;
}
#connection-container .item-cover {
  height: 140px;
}

#connection {
  position: relative;
  width: 100%;
  padding: 0 2% 0 2%;
  overflow: auto;
  max-height: 100%;
}

#connection ion-card {
  border-radius: 15px;
  padding: 15px;
}
#connection ion-card ion-card-header {
  padding: 0;
}
#connection ion-card ion-card-header ion-title {
  font-size: large;
}
#connection ion-card ion-card-content {
  padding: 0;
}

.connection-footer {
  background: none !important;
}
.connection-footer::before {
  content: none !important;
  background: none !important;
}
.connection-footer::after {
  content: none !important;
  background: none !important;
}

.environmentLabel {
  position: absolute;
  bottom: 3px;
  right: 3px;
  font-size: 14px;
  color: var(--ion-color-medium-light);
}`, "",{"version":3,"sources":["webpack://./src/app/account/connection/connection.page.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,kBAAA;AACJ;AACI;EACI,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,kBAAA;EAIA,gGAAA;EACA,YAAA;AADR;AAIQ;EAbJ;IAiBQ,6DAAA;EAHV;AACF;AAMI;EACI,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,kBAAA;EACA,sCAAA;EACA,4BAAA;EACA,kCAAA;EACA,sBAAA;AAJR;AAOI;EACI,2BAAA;AALR;AAQI;EACI,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;AANR;AASI;EACI,aAAA;AAPR;;AAWA;EACI,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AARJ;;AAYI;EACI,mBAAA;EACA,aAAA;AATR;AAWQ;EACI,UAAA;AATZ;AAWY;EACI,gBAAA;AAThB;AAaQ;EACI,UAAA;AAXZ;;AAgBA;EACI,2BAAA;AAbJ;AAeI;EACI,wBAAA;EACA,2BAAA;AAbR;AAgBI;EACI,wBAAA;EACA,2BAAA;AAdR;;AAkBA;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EAEA,eAAA;EACA,oCAAA;AAhBJ","sourcesContent":["#connection-container {\r\n    display: block;\r\n    position: relative;\r\n\r\n    .background {\r\n        width: 100%;\r\n        height: 100%;\r\n        top: 0;\r\n        left: 0;\r\n        position: absolute;\r\n        $background-color: var(--ion-color-primary);\r\n        $background-color-dark: var(--ion-color-tertiary);\r\n        background: -webkit-linear-gradient(-45deg, $background-color 0%, $background-color-dark 100%);\r\n        background: linear-gradient(135deg, $background-color 0%, $background-color-dark 100%);\r\n        opacity: 0.90;\r\n\r\n\r\n        @media (prefers-color-scheme: dark) {\r\n            $background-color: #052829;\r\n            $background-color-dark: #03373e;\r\n            background: -webkit-linear-gradient(-45deg, $background-color 0%, $background-color-dark 100%);\r\n            background: linear-gradient(135deg, $background-color 0%, $background-color-dark 100%);\r\n        }\r\n    }\r\n\r\n    .background-image {\r\n        width: 100%;\r\n        height: 100%;\r\n        top: 0;\r\n        left: 0;\r\n        position: absolute;\r\n        background-image: url('../../../assets/imgs/warehouse.jpg');\r\n        background-repeat: no-repeat;\r\n        background-position: bottom center;\r\n        background-size: cover;\r\n    }\r\n\r\n    > .scroll-content {\r\n        background: none !important;\r\n    }\r\n\r\n    .logo {\r\n        background: none;\r\n        display: block;\r\n        margin-left: auto;\r\n        margin-right: auto;\r\n        text-align: center;\r\n        margin-bottom: 15px;\r\n        width: 30%;\r\n        max-width: 150px;\r\n        max-height: 150px;\r\n    }\r\n\r\n    .item-cover {\r\n        height: 140px;\r\n    }\r\n}\r\n\r\n#connection {\r\n    position: relative;\r\n    width: 100%;\r\n    padding: 0 2% 0 2%;\r\n    overflow: auto;\r\n    max-height: 100%;\r\n}\r\n\r\n#connection {\r\n    ion-card {\r\n        border-radius: 15px;\r\n        padding: 15px;\r\n\r\n        ion-card-header {\r\n            padding: 0;\r\n\r\n            ion-title {\r\n                font-size: large;\r\n            }\r\n        }\r\n\r\n        ion-card-content {\r\n            padding: 0;\r\n        }\r\n    }\r\n}\r\n\r\n.connection-footer {\r\n    background: none !important;\r\n\r\n    &::before {\r\n        content: none !important;\r\n        background: none !important;\r\n    }\r\n\r\n    &::after {\r\n        content: none !important;\r\n        background: none !important;\r\n    }\r\n}\r\n\r\n.environmentLabel {\r\n    position: absolute;\r\n    bottom: 3px;\r\n    right: 3px;\r\n\r\n    font-size: 14px;\r\n    color: var(--ion-color-medium-light);\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
